<template>
  <div class="comp-phone-input-container">
    <div 
    class="comp-phone-row"
    :class="{ 'is-focus': isFocus && !phoneError }"
    >
      <div class="plus" :class="{'plus-disabled': disabled}" >+</div>
      <el-select
        v-model="selectedCountryCode"
        filterable
        :disabled="disabled"
        class="country-select"
        @change="handleCountryChange"
        :class="{
          hideArrow: hideArrow,
        }"
      >
        <el-option
          v-for="item in filteredCountryList"
          :key="item.code"
          :label="item.countryCode"
          :value="item.countryCode"
        >
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.countryCode }}</span>
        </el-option>
      </el-select>
      <el-input
        maxlength="13"
        minlength="6"
        clearable
        :disabled="disabled"
        @focus="handleFocus"
        @blur="handleBlur"
        v-model="phoneNumber"
        :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.enterpriseContactNo"
        class="phone-input"
        :class="{ 'is-error': phoneError}"
        @input="handlePhoneInput"
      />
    </div>
    <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { getCountryCodeList, } from '@/api/system/user';
import { Lang } from '@/lang/lang';
import store from '@/store';
import { ElMessage } from 'element-plus';

const language = store.getters.language;

const props = defineProps({
  hideArrow: {
    type: Boolean,
    default: true,
  },
  modelValue: {
    type: [String, Number],
    default: ''
  },
  // 默认国家区号
  defaultCountryCode: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

// 错误信息
const phoneError = ref('');
const isFocus = ref(false);

// 国家区号列表
const countryCodeList = ref([])
// 筛选后的国家列表
const filteredCountryList = ref([])
// 选中的国家区号
const selectedCountryCode = ref(props.defaultCountryCode)
// 手机号码
const phoneNumber = ref('')

const handleFocus = () => {
  isFocus.value = true;
}
const handleBlur = () => {
  isFocus.value = false;
}

// 获取国家区号列表
const fetchCountryCodes = async () => {
  try {
    const response = await getCountryCodeList()
    const data = response.data.data;
    data.forEach(item => {
      item.label = item.countryCode;
      item.value = item.countryCode;
    });
    const item = data.find(ele => ele.languageType == language) || data[0]
    selectedCountryCode.value = item.countryCode;
    // this.enterpriseForm.areaCode = item.countryCode;
    // this.countryCodeList = data;
    countryCodeList.value = data
    
    // 模拟数据
    // countryCodeList.value = [
    //   { name: '中国', languageType: 'CN', countryCode: '+86' },
    //   { name: '美国', languageType: 'US', countryCode: '+1' },
    //   { name: '英国', languageType: 'GB', countryCode: '+44' },
    //   { name: '日本', languageType: 'JP', countryCode: '+81' },
    //   { name: '韩国', languageType: 'KR', countryCode: '+82' },
    //   { name: '澳大利亚', languageType: 'AU', countryCode: '+61' },
    //   { name: '加拿大', languageType: 'CA', countryCode: '+1' },
    //   { name: '德国', languageType: 'DE', countryCode: '+49' },
    //   { name: '法国', languageType: 'FR', countryCode: '+33' },
    //   { name: '俄罗斯', languageType: 'RU', countryCode: '+7' }
    // ]
    
    filteredCountryList.value = [...countryCodeList.value]
  } catch (error) {
    console.error('获取国家区号列表失败:', error)
  }
}

// 筛选国家 el-select
const filterCountry = (query) => {
  if (query) {
    filteredCountryList.value = countryCodeList.value.filter(item => {
      return (
        item.name.toLowerCase().includes(query.toLowerCase()) ||
        item.countryCode.includes(query)
      )
    })
  } else {
    filteredCountryList.value = [...countryCodeList.value]
  }
}

// 国家区号变化处理
const handleCountryChange = (value) => {
  emitChangeEvent()
}

// 手机号输入处理
const handlePhoneInput = () => {
  // 可以在这里添加手机号格式验证
  const phoneRegex = /^\d{6,13}$/; // 校验 6-13 位数字
  if (phoneNumber.value && !phoneRegex.test(phoneNumber.value)) {
    phoneError.value = Lang.tips.plzInputTruePhoneNumber; // 设置错误信息
  } else {
    phoneError.value = ''; // 清空错误信息
  }
  emitChangeEvent()
}

// 触发change事件和v-model更新
const emitChangeEvent = () => {
  const fullPhone = selectedCountryCode.value + phoneNumber.value
  emit('update:modelValue', fullPhone)
  emit('change', {
    countryCode: selectedCountryCode.value,
    phoneNumber: phoneNumber.value,
    fullPhone
  })
}

// 监听外部modelValue变化
watch(() => props.modelValue, (newVal) => {
  console.log('监听外部modelValue变化', newVal)
  phoneNumber.value = newVal;
}, { immediate: true }) // 确保初始值也会触发

// 初始化
onMounted(() => {
  fetchCountryCodes()
})
</script>

<style lang="scss" scoped>
.comp-phone-input-container {
  .comp-phone-row {
    border: solid 1px #E3E6EA;
    border-radius: 4px;
    display: flex;
    .is-focus {
      border: solid 1px #409eff;
    }
    .plus {
      padding-left: 14px;
      color: #616D7C;
      font-size: 16px;
      font-family: Roboto-Regular;
    }
    .country-select {
      width: 40px;
      border-right: solid 1px #E3E6EA;
      :deep(.el-select__wrapper) {
        box-shadow: none;
        border-radius: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        padding: 4px 12px 4px 2px;
      }
    }
    .hideArrow {
      :deep(.el-select__suffix) {
        display: none;
      }
    }
    
    .phone-input {
      flex: 1;
      :deep(.el-input__wrapper) {
        box-shadow: none;
        border-radius: 0;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .is-error {
      box-shadow: 0 0 0 1px #f56c6c; /* 红色边框 */
      border-top-right-radius:4px;
      border-bottom-right-radius:4px;
      :deep(.el-input__wrapper) {
        padding: 0 11px;
      }
    }
    
    .plus-disabled {
      color: #a8abb2;
    }
  }
  .error-message {
    color: #f56c6c; /* 红色文字 */
    font-size: 12px;
    margin-top: 2px;
    line-height: 14px;
  }
}
</style>